import { Locale } from 'shared/i18n/interface'
import type { GalleryModelsUrl } from 'shared/types/gallery/models'
import type { MTT } from 'shared/types/vp/mtt'

interface GetDefaultQuantityParams {
  locale: Locale
  quantity: GalleryModelsUrl.ValidParsedQsValue<number>
  quantitiesData?: MTT.Models.MsxService.DefaultQuantitiesResult | null
}
export const getDefaultQuantity = ({ locale, quantity, quantitiesData }: GetDefaultQuantityParams): number | undefined => {
  const quantities = quantitiesData && quantitiesData[locale]?.quantities

  // Quantity Priority: URL parameter > MSX default quantity > MSX first quantity
  return quantity || quantities?.default
}
